import { IBookFromPreviousOrder, IBookStrategy } from '@aca-new/app/pages/book/shared/models/interfaces/book-strategy.interface';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { Injectable, Injector } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class AuditsBookStrategyService implements IBookStrategy {
  public constructor(private readonly _injector: Injector) {}

  public getBookFromPreviousUrl(_orderId: string, _serviceType: string): string {
    return '';
  }

  public bookFromPreviousOrder(data: IBookFromPreviousOrder): void {
    this._injector.get(AcaMessageService).postMessageToAca({
      type: EPostMessageType.BOOK_FROM_PREVIOUS_ORDER,
      data: {
        value: data.previousOrder.originData,
        serviceType: data.previousOrder.originData.serviceTypeText,
      },
    });
  }
}
